var _path, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUserBlack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 24,
    viewBox: "0 0 18 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1893_1586)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1893_1586",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 18,
    height: 24
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.28 0.47998H0V23.52H17.28V0.47998Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1893_1586)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.4558 23.0397C14.716 23.0401 14.9734 22.9843 15.2114 22.876C15.4492 22.7677 15.6625 22.6092 15.8373 22.411C16.0121 22.2126 16.1445 21.9788 16.2261 21.7246C16.3077 21.4704 16.3366 21.2013 16.3109 20.9349C15.5041 12.8262 11.3731 7.61661 8.37703 7.68026C5.40586 7.74392 1.55862 13.0289 0.964923 20.9834C0.94624 21.2462 0.980437 21.5102 1.06543 21.7589C1.1504 22.0076 1.28432 22.2355 1.45881 22.4286C1.63329 22.6215 1.84461 22.7754 2.0795 22.8805C2.3144 22.9857 2.56785 23.0399 2.82401 23.0397H14.4558Z",
    fill: "white",
    stroke: "#251F2C",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.6398 9.59992C10.7605 9.59992 12.4798 7.8807 12.4798 5.75992C12.4798 3.63915 10.7605 1.91992 8.6398 1.91992C6.51903 1.91992 4.7998 3.63915 4.7998 5.75992C4.7998 7.8807 6.51903 9.59992 8.6398 9.59992Z",
    fill: "white",
    stroke: "#251F2C",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1893_1586"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 17.28,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserBlack);
export default __webpack_public_path__ + "static/media/user_black.99b2bde1fb783efa97068a4d872a5300.svg";
export { ForwardRef as ReactComponent };